import { render, staticRenderFns } from "./EventRegisterButton.vue?vue&type=template&id=e6bbddd4&"
import script from "./EventRegisterButton.vue?vue&type=script&lang=js&"
export * from "./EventRegisterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../DM.Umbraco.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports